import { connect } from "react-redux";
import { general } from "../../../../../store/action";
import { Accordion, AccordionHeader, Button, Modal } from "react-bootstrap";
import { useState } from "react";
// "https://sai-api.sairantelemetry.ir/multimedia/download/QWu5eriHRN7tpUucvqjIwmP1ZL1nZLz8gpRTBNjmrpZYQQMUVo5cEIepqzpzRZgk1778414714542pTYaOQvU4uTgFUcC";
type OtoscopeImageProps = {
  otoscopeImagePath?: string;
};

const OtoscopeImage = ({ otoscopeImagePath }: OtoscopeImageProps) => {
  const [showModal, setShowModal] = useState(false);
  // otoscopeImagePath =
  //   "https://sai-api.sairantelemetry.ir/multimedia/download/QWu5eriHRN7tpUucvqjIwmP1ZL1nZLz8gpRTBNjmrpZYQQMUVo5cEIepqzpzRZgk1778414714542pTYaOQvU4uTgFUcC";
  // Checks if path exists and isn't just empty spaces
  const hasImage = !!otoscopeImagePath && otoscopeImagePath.trim().length > 0;

  return (
    <>
      <Accordion.Header className="d-flex flex-wrap">
        <div className="flex-fill"></div>
        <span className="font-14 fw-bold me-2 text-black">تصاویر اتوسکوپ</span>
      </Accordion.Header>

      <Accordion.Body className="rounded-bottom bg-primary-10">
        <div className="card-box p-3 d-flex flex-column align-items-center">
          {/* ✅ FIXED: Show content IF hasImage is true */}
          {hasImage ? (
            <div className="position-relative text-center">
              <img
                src={otoscopeImagePath}
                alt="Otoscope"
                className="img-fluid rounded shadow-sm"
                style={{
                  maxHeight: "400px",
                  objectFit: "contain",
                  cursor: "zoom-in",
                }}
                onClick={() => setShowModal(true)}
              />

              {/* ACTION BUTTONS */}
              <div className="mt-3 d-flex gap-2 justify-content-center">
                <a
                  href={otoscopeImagePath}
                  download
                  target="_blank" // Recommended for downloads
                  rel="noreferrer"
                  className="btn btn-outline-primary btn-sm"
                >
                  دانلود
                </a>
              </div>
            </div>
          ) : (
            /* ✅ FIXED: Show alert if NO image */
            <div className="alert alert-info text-center w-100 mb-0">
              تصویری برای این بیمار ثبت نشده است.
            </div>
          )}
        </div>
      </Accordion.Body>

      {/* ✅ MODAL: Simplified condition so it's ready when called */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="text-center bg-dark p-0">
          <img
            src={otoscopeImagePath}
            alt="Otoscope Fullscreen"
            style={{
              maxWidth: "100%",
              maxHeight: "85vh",
              objectFit: "contain",
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) =>
    dispatch(general.handleShowModal(data, body)),
});
export default connect(null, mapDispatchToProps)(OtoscopeImage);
